import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { User } from "models/propTypes/userProfilePropTypes";
import { SalaryDraftProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { FileViewerContainer, TitledContainerInner, EntityCardContent, CommentsView } from "components/common";
import SalaryDraftFooter from "./footer";
import SalaryDraftTopCardContent from "./partials/topCardContent";
import SalaryDraftMainSectionButton from "./salaryDraftMainSectionButton";
import { useSalaryService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SalaryDraft: React.FC<SalaryDraftProps> = (props) => {
  const salaryService = useSalaryService();
  const { salaryDraft, reloadHandler } = props;

  const getMainContainerHeader = () => {
    if (salaryDraft.state === WintSuperkollAPIModel.SalaryDraftState.AtCustomer) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SalaryDraftToDoHeader);
    }
  };

  const getMainContainerSubHeader = () => {
    if (salaryDraft.state === WintSuperkollAPIModel.SalaryDraftState.AtCustomer) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SalaryDraftTodoDescription);
    } else {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.SalaryDraftSubHeaderDescription);
    }
  };

  return (
    <EntityCardContent
      topTodoCard={<SalaryDraftTopCardContent salaryDraft={salaryDraft} reloadHandler={reloadHandler} />}
      todoMainSection={
        <TitledContainerInner header={getMainContainerHeader()} subHeader={getMainContainerSubHeader()}>
          <SalaryDraftMainSectionButton yearAndMonth={salaryDraft!.yearAndMonth} />
        </TitledContainerInner>
      }
      footer={
        salaryDraft.state === WintSuperkollAPIModel.SalaryDraftState.AtCustomer ? (
          <SalaryDraftFooter salaryDraft={salaryDraft!} markAsDoneHandler={reloadHandler} disableSuccessMessages />
        ) : (
          <></>
        )
      }
      infoViewer={
        <FileViewerContainer
          key={salaryDraft?.id}
          parentId={salaryDraft?.id ?? 0}
          meta={salaryDraft.attachments?.map((meta) => ({
            id: meta.id ?? "",
            contentType: meta.contentType,
            numberOfPages: 1,
          }))}
          loading={salaryDraft === undefined}
          getFile={salaryService.getSalaryDraftAttachmentData.bind(null, salaryDraft.id)}
        />
      }
    >
      <CommentsView
        key={salaryDraft?.id}
        parentId={salaryDraft.id}
        title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Messages)}
        comments={
          salaryDraft?.messages?.map((message, index) => ({
            id: index,
            message: message.text ?? "",
            date: message.timestamp,
            from: new User(message.createdBy_Id, message.createdBy ?? "", false),
            isWint: message.createdByWint,
          })) ?? []
        }
        viewCountIncreaseButtonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ShowMore)}
        viewCountIncreaseBy={10}
        defaultViewCount={2}
        totalComments={salaryDraft?.messages?.length}
        defaultExpanded
      />
    </EntityCardContent>
  );
};

export default SalaryDraft;
